// 环境的切换
let baseURL
if (process.env.NODE_ENV == 'development') {
  baseURL = '/api/'
} else if (process.env.NODE_ENV == 'debug') {
  baseURL = '/'
} else if (process.env.NODE_ENV == 'production') {
  baseURL = '/'
}
const serverConfig = {
  baseURL: baseURL,
  useTokenAuthorization: true, //是否开启 token 验证
}
export default serverConfig



// WEBPACK FOOTER //
// ./src/api/baseurl.js